import { DiscountsForm } from 'components/discounts/DiscountsForm/DiscountsForm'
import { useParams } from 'react-router-dom'

export const DiscountsEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <DiscountsForm mode='edit' discountId={id as string} />
}
